import {
  DefinitionList,
  DefinitionListItem,
  MaskCnpj,
  MaskCpf,
} from "@funcional/react-ui";
import { IntlEnum } from "@funcional/react-intl-ui";
import { IProgramBeneficiary } from "@pbm/beneficiaries/contracts";
import { BeneficiaryFieldsList } from ".";

export function ProgramBeneficiaryCard({
  programBeneficiary,
}: {
  programBeneficiary: IProgramBeneficiary;
}) {
  return (
    <>
      <DefinitionList>
        <DefinitionListItem label="Programa">
          {programBeneficiary.program?.name || "N/A"}
        </DefinitionListItem>
        <DefinitionListItem label="CPF">
          <MaskCpf value={programBeneficiary.customerCode} />
        </DefinitionListItem>
        <DefinitionListItem label="CNPJ que realizou inscrição">
          {programBeneficiary.storeCode ? (
            <MaskCnpj value={programBeneficiary.storeCode} />
          ) : (
            "Não informado"
          )}
        </DefinitionListItem>
        <DefinitionListItem label="Canal que realizou inscrição">
          <IntlEnum
            name="authorization_origin"
            value={programBeneficiary.origin}
          />
        </DefinitionListItem>
        <DefinitionListItem label="Nome">
          {programBeneficiary.name}
        </DefinitionListItem>
        <DefinitionListItem label="Data">
          {programBeneficiary.createdAt}
        </DefinitionListItem>
      </DefinitionList>

      {(programBeneficiary.fields || []).length > 0 ? (
        <div className="mt-8">
          <BeneficiaryFieldsList fields={programBeneficiary.fields || []} />
        </div>
      ) : null}
    </>
  );
}
